import tasks from "@/plugins/tasks/tasks";

class Scheduler {

    constructor () {
        this.handles = []
        this.initTasks()
    }

    initTasks() {
        // TODO: on fail, pause execution, and try again later
        tasks.forEach(task => {
            this.handles.push(setInterval(task.handler, task.repeatAfterSeconds));
        })
    }

    stopTasks() {
        this.handles.forEach(handle => {
            clearInterval(handle)
        })
    }
}
export default {
    install (Vue) {
        Vue.prototype.$scheduler = new Scheduler();
    }
};
